<template>
    <a-card :title="$t('screenTitle.userListManager')">
        <a-alert show-icon class="mb-20">
            <template #icon>
                <sync-outlined :spin="fetchingOnlineCount" />
            </template>
            <template #message>Tổng số tài khoản đang online là: {{ number_format(onlineCount) }}</template>
        </a-alert>

        <a-collapse class="mb-20">
            <a-collapse-panel header="Tìm tài khoản bằng ID nhân vật trong game">
                <a-form ref="formType" :model="formModel" @finish="onFinish" :scrollToFirstError="true"
                    layout="vertical">
                    <a-form-item :label="$t('labelText.server_name')" name="server_id"
                        :rules="{required: true, trigger: ['change', 'blur']}">
                        <ServerSelectView v-model="formModel.server_id" />
                    </a-form-item>

                    <a-form-item :label="$t('labelText.char_guid')" name="charguid" required
                        :rules="[{len: 8}, {pattern: /^[0-9a-fA-F]+$/}]">
                        <a-input v-model:value="formModel.charguid" placeholder="3C3ABCDE" />
                    </a-form-item>

                    <a-form-item>
                        <a-space>
                            <a-button type="primary" html-type="submit" :loading="isLoading">{{ $t('text.search') }}
                            </a-button>

                            <a-tooltip title="Chuyển sang tài khoản khác">
                                <a-button type="primary" @click="() => {
                                    isShowChangeCharAccname = true;
                                    selectingChar = {
                                        server_id: formModel.server_id,
                                        accname: '',
                                        charguid_hex: formModel.charguid,
                                        charguid: parseInt(formModel.charguid, 16),
                                    };
                                }">
                                    <template #icon>
                                        <user-switch-outlined />
                                    </template>
                                </a-button>
                            </a-tooltip>
                        </a-space>
                    </a-form-item>
                </a-form>
            </a-collapse-panel>
            <a-collapse-panel header="Thống kê tổng tài sản trong game">
                <a-form-item :label="$t('labelText.server_name')" required>
                    <ServerSelectView v-model="statisticsServerId" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" :disabled="!statisticsServerId" :loading="isFetchingStatistics"
                        @click="() => onStatistics(statisticsServerId)">{{ $t('text.reload') }}</a-button>
                </a-form-item>
                <a-card :loading="isFetchingStatistics">
                    <div>Tổng số nhân vật: {{ number_format(statistics.char_total) }}</div>
                    <br />

                    <div>Tổng số KNB trong char: {{ number_format(statistics.yuanbao_total_char) }}</div>
                    <div v-if="statistics.yuanbao_total_iteminfo">Tổng số KNB trong Item: {{ number_format(statistics.yuanbao_total_iteminfo) }}</div>
                    <div v-if="statistics.yuanbao_total_pshop">Tổng số KNB trong TH: {{ number_format(statistics.yuanbao_total_pshop) }}</div>
                    <div>Tổng số KNB: {{ number_format(statistics.yuanbao_total) }}</div>
                    <br />

                    <div>Tổng số Điểm Tặng trong char: {{ number_format(statistics.zengdian_total_char) }}</div>
                    <div v-if="statistics.zengdian_total_iteminfo">Tổng số Điểm Tặng trong item: {{ number_format(statistics.zengdian_total_iteminfo) }}</div>
                    <div v-if="statistics.zengdian_total_pshop">Tổng số Điểm Tặng trong TH: {{ number_format(statistics.zengdian_total_pshop) }}</div>
                    <div>Tổng số Điểm Tặng: {{ number_format(statistics.zengdian_total) }}</div>
                    <br />

                    <div>Tổng số Vàng trên người: {{ number_format(Math.floor(statistics.vmoney_total / 100 / 100)) }}</div>
                    <div>Tổng số Vàng Khoá trên người: {{ number_format(Math.floor(statistics.moneyjz_total / 100 / 100)) }}</div>
                    <br />
                    <a-table
                        v-if="statistics.iteminfo_same_guid && statistics.iteminfo_same_guid.length"
                        :columns="Object.keys(statistics.iteminfo_same_guid[0]).map(v => ({title: v, dataIndex: v}))"
                        :data-source="statistics.iteminfo_same_guid"
                        :scroll="{x: '100%'}"
                    >
                        <template #title>Danh sách item trùng GUID item</template>
                    </a-table>
                    <a-table
                        v-if="statistics.pshop_same_guid && statistics.pshop_same_guid.length"
                        :columns="Object.keys(statistics.pshop_same_guid[0]).map(v => ({title: v, dataIndex: v}))"
                        :data-source="statistics.pshop_same_guid"
                        :scroll="{x: '100%'}"
                    >
                        <template #title>Danh sách item trùng GUID TH</template>
                    </a-table>
                    <hr />
                    <div>Check lúc: {{ (new Date()) }}</div>
                </a-card>
            </a-collapse-panel>
            <a-collapse-panel header="Danh sách nhân vật có tên tài khoản không hợp lệ (block/hack)">
                <a-form :model="formModelInvalidChars" @finish="onSubmitGetInvalidChars" layout="inline">
                    <a-form-item :label="$t('labelText.server_name')" name="server_id" required>
                        <ServerSelectView v-model="formModelInvalidChars.server_id" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" :loading="isLoadingInvalidChars"
                            :disabled="!formModelInvalidChars.server_id">{{ $t('text.search') }}</a-button>
                    </a-form-item>
                </a-form>

                <a-table :dataSource="invalidChars" :columns="columnsInvalidChars" :loading="isLoadingInvalidChars">
                    <template #bodyCell="{ column, record: char_record }">
                        <template v-if="column.key === 'action'">
                            <a-space>
                                <a-tooltip title="Chuyển sang tài khoản khác">
                                    <a-button type="primary"
                                        @click="() => {isShowChangeCharAccname = true; selectingChar = char_record;}">
                                        <template #icon>
                                            <user-switch-outlined />
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </a-space>
                        </template>
                    </template>
                </a-table>
            </a-collapse-panel>
        </a-collapse>

        <a-table :dataSource="dataSource" :columns="columns" :pagination="pagination" @change="onChange"
            :loading="isLoading" v-model:expandedRowKeys="expandedRowKeys" :row-key="record => record.id"
            :scroll="{x: '100%'}"
        >
            <template #bodyCell="{ column, record, text }">
                <template v-if="column.key === 'action'">
                    <a-space>
                        <a-tooltip title="Thông tin nhân vật trong game">
                            <a-button type="primary" @click="showCharInGame(record)">
                                <template #icon>
                                    <audit-outlined />
                                </template>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Reset trạng thái [Đang đăng nhập]">
                            <a-button type="primary" @click="resetLoggedIn(record)" :disabled="!record.pc_online">
                                <template #icon>
                                    <logout-outlined />
                                </template>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Kick khỏi game">
                            <a-button type="primary" danger
                                @click="() => { isShowKickAssModal = true; selectingKickAss = record; }"
                                :disabled="!record.pc_online">
                                <template #icon>
                                    <thunderbolt-outlined />
                                </template>
                            </a-button>
                        </a-tooltip>
                        <a-tooltip title="Xoá thông tin">
                            <a-button type="primary" danger @click="deleteConfirm(record)"><template #icon>
                                    <clear-outlined />
                                </template></a-button>
                        </a-tooltip>
                    </a-space>
                </template>
                <template v-else-if="column.dataIndex === 'role'">
                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="(e) => changeRole(record)(e)">
                                <a-menu-item
                                    v-for="roleK in Object.keys(UserRole).filter((v) => (isNaN(Number(v)) && (UserRole[v as keyof typeof UserRole] !== UserRole.GOD)))"
                                    :key="UserRole[roleK as keyof typeof UserRole]"
                                    :disabled="UserRole[roleK as keyof typeof UserRole] === text">
                                    <span>{{ userRoleText(UserRole[roleK as keyof typeof UserRole]) }}</span>
                                </a-menu-item>
                            </a-menu>
                        </template>
                        <a-tag :color="userRoleColor(text)">{{ userRoleText(text) }}
                            <DownOutlined />
                        </a-tag>
                    </a-dropdown>
                </template>
                <template v-else-if="column.dataIndex === 'is_lock'">
                    <a-button :type="text ? 'primary' : 'ghost'" @click="switchLock(record)">
                        <template #icon>
                            <lock-outlined v-if="!text" />
                            <KeyOutlined v-else />
                        </template>
                    </a-button>
                </template>
            </template>

            <template #customFilterDropdown="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }">
                <div style="padding: 8px">
                    <a-input ref="searchInput" :placeholder="`Search ${column.dataIndex}`" :value="selectedKeys"
                        style="width: 188px; margin-bottom: 8px; display: block"
                        @change="(e: any) => setSelectedKeys(e.target.value)"
                        @pressEnter="handleSearch(selectedKeys, confirm, column.dataIndex)" />
                    <a-button type="primary" size="small" style="width: calc(60% - 8px); margin-right: 8px"
                        @click="handleSearch(selectedKeys, confirm, column.dataIndex)">
                        <template #icon>
                            <SearchOutlined />
                        </template>
                        <span>{{ $t('text.search') }}</span>
                    </a-button>
                    <a-button size="small" style="width: 40%" @click="handleReset(clearFilters)">Reset</a-button>
                </div>
            </template>

            <template #expandedRowRender="{ record }">
                <a-collapse class="mb-20">
                    <a-collapse-panel header="Xem toàn bộ thông tin ẩn">
                        <div>{{ $t('labelText.user_email') }}: {{ record.email || $t('text.notUpdated') }}</div>
                        <div>{{ $t('labelText.user_tel') }}: {{ record.tel || $t('text.notUpdated') }}</div>
                        <div>{{ $t('labelText.user_question') }}: {{ record.question || $t('text.notUpdated') }}</div>
                        <div>{{ $t('labelText.user_answer') }}: {{ record.answer || $t('text.notUpdated') }}</div>
                        <div>{{ $t('labelText.user_coin') }}: {{ number_format(record.coin) }}</div>
                        <div>{{ $t('labelText.user_promotion_coin') }}: {{ number_format(record.promotion_coin) }}</div>
                        <div>{{ $t('labelText.user_point') }}: {{ number_format(record.point) }}</div>
                    </a-collapse-panel>
                </a-collapse>
                <a-form ref="formType" @submit="() => onSubmitGetChars(record)" layout="inline">
                    <a-form-item :label="$t('labelText.server_name')">
                        <ServerSelectView v-model="record.server_id" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" :loading="record.isLoadingChars"
                            :disabled="!record.server_id">{{ $t('text.search') }}</a-button>
                    </a-form-item>
                </a-form>

                <a-table :dataSource="record.chars" :columns="columnsChars" :loading="record.isLoadingChars">
                    <template #bodyCell="{ column, record: char_record }">
                        <template v-if="column.key === 'action'">
                            <a-space>
                                <a-tooltip title="Chuyển sang tài khoản khác">
                                    <a-button type="primary"
                                        @click="() => {isShowChangeCharAccname = true; selectingChar = char_record;}">
                                        <template #icon>
                                            <user-switch-outlined />
                                        </template>
                                    </a-button>
                                </a-tooltip>

                                <a-tooltip title="Fix kẹt map">
                                    <a-button type="primary" disabled @click="fixMapStuck(char_record)">
                                        <template #icon>
                                            <environment-outlined />
                                        </template>
                                    </a-button>
                                </a-tooltip>
                            </a-space>
                        </template>
                    </template>
                </a-table>
            </template>
        </a-table>

        <a-modal v-model:open="isShowKickAssModal" :footer="null" title="Kick người chơi khỏi game">
            <a-form layout="vertical" :model="selectingKickAss" @finish="kickFromGame">
                <a-form-item :label="$t('labelText.user_name')" required>
                    <a-input :value="selectingKickAss.name" disabled />
                </a-form-item>
                <a-form-item name="id" required hidden>
                    <a-input :value="selectingKickAss.id" disabled />
                </a-form-item>
                <a-form-item :label="$t('labelText.server_name')" name="server_id"
                    :rules="{required: true, trigger: ['change', 'blur']}">
                    <ServerSelectView v-model="selectingKickAss.server_id" />
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" html-type="submit" :loading="isKickingAss">Kick</a-button>
                </a-form-item>
            </a-form>
        </a-modal>

        <a-modal v-model:open="isShowChangeCharAccname" :footer="null" title="Chuyển nhân vật sang tài khoản khác">
            <a-form layout="vertical" :model="selectingChar" @submit="() => changeCharAccname(selectingChar)">
                <a-form-item label="Nhân vật" required>
                    <a-input
                        :value="`${selectingChar.charname_utf8} (${selectingChar.level}) - ${selectingChar.charguid_hex}`"
                        readonly />
                </a-form-item>

                <a-form-item :label="$t('labelText.user_name')" required>
                    <a-input v-model:value="selectingChar.accname" />
                </a-form-item>

                <a-form-item>
                    <a-button type="primary" html-type="submit"
                        :disabled="!selectingChar.accname || !selectingChar.accname.length || !selectingChar.server_id || !selectingChar.charguid"
                        :loading="selectingChar.isChangingAccname">Chuyển</a-button>
                </a-form-item>
            </a-form>

            <a href="https://www.rapidtables.com/convert/number/decimal-to-hex.html" target="_blank">Chuyển đổi số sang CharGUID</a>
            <a-list item-layout="vertical" :pagination="paginationChangeCharAccnameHistory" :data-source="dataSourceChangeCharAccnameHistory">
                <template #renderItem="{ item }">
                    <a-list-item key="item.id">{{ item.value }}<br />{{ item.created_at }}</a-list-item>
                </template>
            </a-list>
        </a-modal>
    </a-card>
</template>

<script lang="ts">
import { defineComponent, h, onMounted, onUnmounted, reactive, ref } from "vue";
import { useI18n } from "vue-i18n";

import { Alert, Button, Card, Collapse, Dropdown, Form, Input, List, Menu, message, Modal, Space, Table, TablePaginationConfig, Tag, Tooltip } from "ant-design-vue";
import {
    ClearOutlined, SearchOutlined, LockOutlined, KeyOutlined, DownOutlined, LogoutOutlined, ThunderboltOutlined, SyncOutlined, AuditOutlined,
    UserSwitchOutlined, EnvironmentOutlined,
} from '@ant-design/icons-vue';
import { ColumnType } from "ant-design-vue/lib/table";
import { MenuClickEventHandler, MenuInfo } from "ant-design-vue/lib/menu/src/interface";

import { RouteName } from "@/router";
import ApiRequest from "@/utils/ApiRequest";
import { UserRole } from "@/store/modules/user";
import { number_format, viscii2utf8 } from "@/utils/helpers";
import ServerSelectView from '@/components/ServerSelectView.vue';
import { menpaiName,  } from '@/utils/TCharInfo';
import { PaginationProps } from "ant-design-vue/lib/pagination";

export const userRoleText = (role: UserRole): string => {
    switch (role) {
        case UserRole.GOD:
            return 'God';

        case UserRole.MASTER_ADMIN:
            return 'Master Admin';

        case UserRole.MODERATOR:
            return 'Moderator';

        case UserRole.MANAGER:
            return 'Manager';

        case UserRole.USER:
            return 'User';

        default:
            return 'Unknown';
    }
}

export const userRoleColor = (role: UserRole): string => {
    switch (role) {
        case UserRole.GOD:
            return 'red';

        case UserRole.MASTER_ADMIN:
            return 'purple';

        case UserRole.MANAGER:
            return 'blue';

        case UserRole.MODERATOR:
            return 'cyan';

        case UserRole.USER:
            return 'green';

        default:
            return 'white';
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type UserModel = any;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type CharModel = any;

export default defineComponent({
    components: {
        ACard: Card,
        ATable: Table,
        AButton: Button,
        ASpace: Space,
        ATag: Tag,
        AInput: Input,
        ADropdown: Dropdown,
        AMenu: Menu,
        AMenuItem: Menu.Item,
        ATooltip: Tooltip,
        AAlert: Alert,
        AForm: Form,
        AFormItem: Form.Item,
        ACollapse: Collapse,
        ACollapsePanel: Collapse.Panel,
        AModal: Modal,
        AList: List,
        AListItem: List.Item,

        ServerSelectView,

        ClearOutlined,
        SearchOutlined,
        LockOutlined,
        KeyOutlined,
        DownOutlined,
        LogoutOutlined,
        ThunderboltOutlined,
        SyncOutlined,
        AuditOutlined,
        UserSwitchOutlined,
        EnvironmentOutlined,
    },

    setup() {
        const { t } = useI18n();

        const isLoading = ref(true);
        const dataSource = ref([]);
        const columns = ref<ColumnType[]>([
            {
                title: t('labelText.user_name'),
                dataIndex: 'name',
                customFilterDropdown: true,
            },
            {
                title: t('labelText.user_role'),
                dataIndex: 'role',
                filters: Object.keys(UserRole).filter((v) => isNaN(Number(v))).map((v) => {
                    const role = UserRole[v as keyof typeof UserRole];
                    return ({ text: userRoleText(role), value: role });
                }),
            },
            {
                title: t('labelText.user_is_lock'),
                dataIndex: "is_lock",
                filters: [
                    { text: t('labelText.user_is_lock_true'), value: 1 },
                    { text: t('labelText.user_is_lock_false'), value: 0 },
                ],
            },
            {
                title: t('labelText.created_at'),
                dataIndex: "created_at",
            },
            {
                title: t('labelText.updated_at'),
                dataIndex: 'updated_at',
            },
            {
                title: t('text.action'),
                key: 'action',
            },
        ]);
        const pagination = ref<TablePaginationConfig>({
            current: 1,
        });

        const formModel = reactive({
            server_id: undefined,
            charguid: '',
        });

        const formModelInvalidChars = reactive({
            server_id: undefined,
        });
        const columnsInvalidChars = ref<ColumnType[]>([
            {
                title: 'ID',
                dataIndex: 'charguid_hex',
            },
            {
                title: 'Tên tài khoản',
                dataIndex: 'accname',
            },
            {
                title: 'Tên nhân vật',
                dataIndex: 'charname_utf8',
            },
            {
                title: 'Môn phái',
                dataIndex: 'menpai',
                customRender: ({ text }) => menpaiName(text),
            },
            {
                title: 'Cấp độ',
                dataIndex: 'level',
            },
            {
                title: 'KNB',
                dataIndex: 'yuanbao',
                customRender: ({ text }) => number_format(text),
            },
            {
                title: 'Vàng',
                dataIndex: 'vmoney',
                customRender: ({ text }) => number_format(Math.floor(text / 100 / 100)),
            },
            {
                title: 'Điểm tặng',
                dataIndex: 'zengdian',
                customRender: ({ text }) => number_format(text),
            },
            {
                title: t('text.action'),
                key: 'action',
            },
        ]);
        const isLoadingInvalidChars = ref(false);
        const invalidChars = ref([]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const onSubmitGetInvalidChars = (values: any) => {
            isLoadingInvalidChars.value = true;
            ApiRequest.get(`/servers/${values.server_id}/invalid-chars`)
                .then(res => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    invalidChars.value = res.data.data.map((v: any) => ({
                        ...v,
                        charguid_hex: v.charguid.toString(16).toUpperCase(),
                        charname_utf8: viscii2utf8(v.charname),
                        server_id: values.server_id,
                    }));
                })
                .finally(() => {
                    isLoadingInvalidChars.value = false;
                });
        };

        const expandedRowKeys = ref<string[]>([]);
        const filters = ref({});

        const fetchData = () => {
            isLoading.value = true;

            ApiRequest.get('/users', {
                page: pagination.value.current,
                ...filters.value,
                // server_id: formModel.server_id ? formModel.server_id : undefined,
                // charguid: formModel.charguid.length ? formModel.charguid : undefined,
            }).then((response) => {
                const resData = response.data;
                dataSource.value = resData.data;

                ApiRequest.setPaginate(pagination.value, resData);
            })
            .finally(() => {
                isLoading.value = false;
            });
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const onFinish = (values: any) => {
            filters.value = values;
            pagination.value.current = 1;
            fetchData();
        }

        // pagination.value.onChange = (page) => {
        //     fetchData(page);
        // };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deleteConfirm = (record: any) => {
            Modal.confirm({
                title: t('message.userListClearConfirmContent'),
                content: h('p', {}, [
                    h('h2', {}, record.name),

                    h('div', {}, t('labelText.user_email')),
                    h('div', {}, t('labelText.user_tel')),
                    h('div', {}, t('labelText.password2')),
                    h('div', {}, t('labelText.user_ask')),
                    h('div', {}, t('labelText.user_answer')),
                ]),
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.del('/users/' + record.id + '/info').then(() => {
                        message.success(t('message.deleteSuccess'));
                    })
                    .finally(() => {
                        fetchData();
                    });
                },
            });
        };

        const switchLock = (record: UserModel) => {
            const is_lock = !record.is_lock;
            Modal.confirm({
                title: is_lock ? t('message.userLockConfirm') : t('message.userUnlockConfirm'),
                content: record.name,
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.post('/users/' + record.id + '/set-lock', {
                        is_lock: is_lock,
                    }).then(() => {
                        message.success(t('message.updateSuccess'));
                    })
                    .finally(() => {
                        fetchData();
                    });
                },
            });
        };

        const resetLoggedIn = (record: UserModel) => {
            Modal.confirm({
                title: 'Bạn có chắc chắn muốn reset trạng thái đăng nhập của tài khoản này?',
                content: record.name,
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.post('/users/' + record.id + '/reset-logged-in')
                        .then(() => {
                            message.success(t('message.updateSuccess'));
                        })
                        .finally(() => {
                            fetchData();
                        });
                },
            });
        };

        const isShowKickAssModal = ref(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const selectingKickAss = ref<any>({});
        const isKickingAss = ref(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const kickFromGame = (values: any) => {
            isKickingAss.value = true;
            ApiRequest.post('/users/'+selectingKickAss.value.id+'/kick-ass', values)
                .then(() => {
                    message.success(t('message.updateSuccess'));
                })
                .finally(() => {
                    isKickingAss.value = false;

                    fetchData();
                });
        };

        const changeRole = (record: UserModel): MenuClickEventHandler => (e: MenuInfo) => {
            const roleTo = e.key as UserRole;
            Modal.confirm({
                title: t('message.userSetRoleConfirm'),
                content: `${record.name}: [${userRoleText(record.role)}] => [${userRoleText(roleTo)}]`,
                autoFocusButton: 'cancel',
                maskClosable: true,
                onOk: async () => {
                    return ApiRequest.post('/users/' + record.id + '/role', {
                        role: roleTo,
                    }).then(() => {
                        message.success(t('message.updateSuccess'));
                    })
                    .finally(() => {
                        fetchData();
                    });
                },
            });
        };

        const showCharInGame = (record: UserModel) => {
            const indexOfId = expandedRowKeys.value.indexOf(record.id);
            if (indexOfId === -1) {
                expandedRowKeys.value.push(record.id);
            } else {
                expandedRowKeys.value.splice(indexOfId, 1);
            }
        };

        const columnsChars = ref<ColumnType[]>([
            {
                title: 'ID',
                dataIndex: 'charguid_hex',
            },
            {
                title: 'Tên nhân vật',
                dataIndex: 'charname_utf8',
            },
            {
                title: 'Môn phái',
                dataIndex: 'menpai',
                customRender: ({ text }) => menpaiName(text),
            },
            {
                title: 'Cấp độ',
                dataIndex: 'level',
            },
            {
                title: 'KNB',
                dataIndex: 'yuanbao',
                customRender: ({ text }) => number_format(text),
            },
            {
                title: 'Vàng',
                dataIndex: 'vmoney',
                customRender: ({ text }) => number_format(Math.floor(text / 100 / 100)),
            },
            {
                title: 'Điểm tặng',
                dataIndex: 'zengdian',
                customRender: ({ text }) => number_format(text),
            },
            {
                title: t('text.action'),
                key: 'action',
            },
        ]);
        const onSubmitGetChars = (record: UserModel) => {
            record.isLoadingChars = true;
            ApiRequest.get(`/servers/${record.server_id}/user-chars/${record.id}`)
                .then(res => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    record.chars = res.data.data.map((v: any) => ({
                        ...v,
                        charguid_hex: v.charguid.toString(16).toUpperCase(),
                        charname_utf8: viscii2utf8(v.charname),
                        server_id: record.server_id,
                    }));
                })
                .finally(() => {
                    record.isLoadingChars = false;
                });
        };

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const fixMapStuck = (record: CharModel) => {
            // console.log(record);
        };

        const isShowChangeCharAccname = ref(false);
        const selectingChar = ref<CharModel>({});
        const changeCharAccname = (record: CharModel) => {
            selectingChar.value.isChangingAccname = true;

            ApiRequest.post(`/servers/${record.server_id}/set-char-accname`, {
                accname: record.accname,
                charguid: record.charguid,
            })
                .then(() => {
                    message.success(t('message.success'));
                })
                .finally(() => {
                    selectingChar.value.isChangingAccname = false;
                });
        };

        const onlineCount = ref(0);
        const fetchingOnlineCount = ref(false);
        const fetchOnlineCount = () => {
            if (fetchingOnlineCount.value) {
                return;
            }

            fetchingOnlineCount.value = true;

            ApiRequest.get('/users/logged-in-count')
                .then(res => {
                    onlineCount.value = res.data.data;
                })
                .finally(() => {
                    fetchingOnlineCount.value = false;
                });
        };
        const fetchTimeOut = setInterval(fetchOnlineCount, 10000);

        const isFetchingStatistics = ref(false);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const statistics = ref<any>({});
        const statisticsServerId = ref();
        const onStatistics = (value: number) => {
            if (!value) {
                return;
            }

            isFetchingStatistics.value = true;
            ApiRequest.get(`/servers/${value}/statistics`)
                .then(res => {
                    statistics.value = res.data.data;
                })
                .finally(() => {
                    isFetchingStatistics.value = false;
                });
        };

        /* eslint-disable @typescript-eslint/no-explicit-any */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const handleSearch = (selectedKeys: any, confirm: any, dataIndex: any) => {
            confirm();
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleReset = (clearFilters: any) => {
            clearFilters({ confirm: true });
        };

        /* eslint-disable @typescript-eslint/no-explicit-any */
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const onChange = (_pagination: TablePaginationConfig, fils: any, _sorter: any) => {
            pagination.value = _pagination;

            filters.value = {
                ...fils,
                role: fils.role ? fils.role.join(',') : undefined,
                is_lock: fils.is_lock ? fils.is_lock.join(',') : undefined,
            };

            fetchData();
        };

        const dataSourceChangeCharAccnameHistory = ref([]);

        const paginationChangeCharAccnameHistory = ref<PaginationProps>({
            current: 1,
        });

        const fetchDataChangeCharAccnameHistory = () => {
            ApiRequest.get('/servers/chars-move-history', {
                page: paginationChangeCharAccnameHistory.value.current,
            }).then((response) => {
                const resData = response.data;
                dataSourceChangeCharAccnameHistory.value = resData.data;

                ApiRequest.setPaginate(paginationChangeCharAccnameHistory.value, resData);
            })
        };

        paginationChangeCharAccnameHistory.value.onChange = (page) => {
            paginationChangeCharAccnameHistory.value.current = page;
            fetchDataChangeCharAccnameHistory();
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onMounted(() => {
            fetchData();

            fetchOnlineCount();

            fetchDataChangeCharAccnameHistory();
        });

        onUnmounted(() => {
            clearInterval(fetchTimeOut);
        });

        return {
            dataSource,
            columns,
            pagination,
            isLoading,

            onSubmitGetInvalidChars,
            columnsInvalidChars,
            invalidChars,
            formModelInvalidChars,
            isLoadingInvalidChars,

            dataSourceChangeCharAccnameHistory,
            paginationChangeCharAccnameHistory,
            // isLoadingChangeCharAccnameHistory,

            fetchData,
            deleteConfirm,
            switchLock,
            changeRole,
            handleReset,
            handleSearch,
            onChange,
            expandedRowKeys,

            kickFromGame,
            isShowKickAssModal,
            selectingKickAss,
            isKickingAss,

            columnsChars,
            showCharInGame,
            onSubmitGetChars,
            fixMapStuck,
            changeCharAccname,
            isShowChangeCharAccname,
            selectingChar,

            onStatistics,
            isFetchingStatistics,
            statistics,
            statisticsServerId,

            resetLoggedIn,

            userRoleText,
            userRoleColor,

            onlineCount,
            fetchingOnlineCount,

            number_format,

            formModel,
            onFinish,

            RouteName,

            UserRole,
        };
    },
})
</script>

<style scoped>

</style>
